/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

export const preBuiltEntitiyNames = {
  'age': 'Alter einer Person',
  'datetimeV2': 'Datum & Zeit',
  'dimension': 'Dimension',
  'email': 'E-Mail-Adresse',
  'keyPhrase': 'Schlüsselaussage',
  'money': 'Geldbetrag',
  'number': 'Nummer',
  'ordinal': 'Aufzählung',
  'percentage': 'Prozentwert',
  'phonenumber': 'Telefonnummer',
  'temperature': 'Temperatur',
  'url': 'URL'
};